// Shared video types

export interface Video {
  bvid: string;
  aid: number | null;
  title: string;
  author: {
    mid: number | null;
    name: string | null;
  };
  pubdate: number;
  year: number;
  category: string | null;
  duration: number | null;
  view: number;
  like: number;
  cover: string | null;
  channel: number;
  tags: string[];
}

export interface ApiSuccess<T> {
  success: true;
  data: T;
}

export interface ApiError {
  success: false;
  error: string;
}

export type ApiResponse<T> = ApiSuccess<T> | ApiError;

export type RandomMode = "random" | "archive" | "lost" | "classic";

export interface RandomParams {
  year?: number | null;
  category?: string | null;
  mode?: RandomMode;
  blockedTags?: string[];
}

export const CATEGORIES = [
  { id: "动画", en: "anime" },
  { id: "音乐", en: "music" },
  { id: "游戏", en: "game" },
  { id: "舞蹈", en: "dance" },
  { id: "鬼畜", en: "kichiku" },
  { id: "知识", en: "knowledge" },
  { id: "科技", en: "tech" },
  { id: "生活", en: "life" },
  { id: "娱乐", en: "ent" },
  { id: "影视", en: "movie" },
] as const;

export const YEARS = (() => {
  const arr: number[] = [];
  for (let y = 2009; y <= 2026; y++) arr.push(y);
  return arr;
})();

export const STORAGE_KEYS = {
  history: "bilitime_history",
  favorites: "bilitime_favorites",
  settings: "bilitime_settings",
} as const;

export interface WatchStats {
  videoCount: number;
  watchTimeMs: number;
  tagCounts: Record<string, number>;
  seenBvids: Record<string, boolean>;
}

export interface HistoryEntry {
  bvid: string;
  title: string;
  year: number;
  category: string | null;
  author: string | null;
  watchedAt: number; // unix ms
}

export interface FavoriteEntry {
  bvid: string;
  title: string;
  year: number;
  category: string | null;
  author: string | null;
  addedAt: number;
}

export interface Settings {
  muted: boolean;
  volume: number;
  unknownMode: boolean;
  soundFx: boolean;
}
